// extracted by mini-css-extract-plugin
export var categoryProduct = "br10-ib";
export var categoryProductImg = "br10-jb";
export var categoryProductImgColors = "br10-kb";
export var categoryProductName = "br10-lb";
export var categoryProductOrigin = "br10-mb";
export var categoryProductPriceCn = "br10-nb";
export var categoryProductPriceEn = "br10-ob";
export var categoryProductSaleView = "br10-rb";
export var categoryProductTag = "br10-pb";
export var categoryProductTagLine = "br10-qb";